// This file is automatically generated. DO NOT EDIT
 // Application version 
export const name = 'portal'
export const version = '5.4.3'